'use client';
import { useRouter } from '@ninjacart/nc-nk-web-deps';
import { addEventParam, INinjaEvent,useQueuedEventStore } from '@ninjacart/nc-events-sdk-v2';
import { KissanEventType } from '@ninjacart/nc-nk-store';

export function useHomeAnalytics() {
  const { push } = useRouter();
  const enqueue = useQueuedEventStore((state) => state.enqueue);
  
  const handleSearch = (value) => {
    push({
      pathname: `/globalSearch`,
      query: {
        openSpeechToTextBottomSheet: value,
      },
    });
    
    const homeSearchclickEvent: INinjaEvent = {
      name: KissanEventType.HOME_FLOAT_ICON_SEARCH_CLICK,
      screenDetails: { screen: 'feed page' },
    };
    enqueue(homeSearchclickEvent);
  };
  
  const navigateToModeration = () => {
    push('/moderation');
  };
  
  const logVideoView = (videoId, index) => {
    const videoViewEvent: INinjaEvent = {
      name: KissanEventType.DATA_VIEWED_MORETHAN_ONE_SECOND,
      screenDetails: { screen: 'feed page' },
      eventParams: [
        addEventParam('videoId', videoId),
        addEventParam('scrolledIndex', index),
      ],
    };
    enqueue(videoViewEvent);
  };
  
  return {
    handleSearch,
    navigateToModeration,
    logVideoView,
  };
}